import React, { createContext, useContext, useState } from "react";

type PagamentoAtual = {
  idAssinatura: string;
  planoModeloId: string;
};

export type Ciclo = "MONTHLY" | "YEARLY";

export type PlanoSelecionado = {
  id: string;
  nome: string;
  preco: number;
  ciclo: Ciclo;
  valorMensal?: number;
};

type PagamentoContextType = {
  pagamentoAtual: PagamentoAtual | null;
  setPagamentoAtual: (p: PagamentoAtual | null) => void;
  planoSelecionado: PlanoSelecionado | null;
  setPlanoSelecionado: (p: PlanoSelecionado | null) => void;
  modalPagamentoOpen: boolean;
  setModalPagamentoOpen: (open: boolean) => void;
};

const PagamentoContext = createContext<PagamentoContextType | undefined>(undefined);

export const PagamentoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [pagamentoAtual, setPagamentoAtual] = useState<PagamentoAtual | null>(null);
  const [planoSelecionado, setPlanoSelecionado] = useState<PlanoSelecionado | null>(null);
  const [modalPagamentoOpen, setModalPagamentoOpen] = useState(false);

  return (
    <PagamentoContext.Provider
      value={{
        pagamentoAtual,
        setPagamentoAtual,
        planoSelecionado,
        setPlanoSelecionado,
        modalPagamentoOpen,
        setModalPagamentoOpen,
      }}
    >
      {children}
    </PagamentoContext.Provider>
  );
};

export const usePagamentoContext = () => {
  const context = useContext(PagamentoContext);
  if (!context) {
    throw new Error("usePagamentoContext deve ser usado dentro de PagamentoProvider");
  }
  return context;
};
